import { TStatusCallbak, reqPost, reqGet, TOneItemCallback } from 'HttpRequests'
import { ICartOrder, IOrderPrice } from '../order_components/IOrder'

function reqGetCartOrder(callback: (newOrder: ICartOrder) => void) {
  reqGet('api/get_cart_order/', callback)
}

function reqCalculateCartOrderPrice(
  callback: (bidPrice: IOrderPrice) => void,
  error?: VoidFunction
) {
  reqGet('api/calculate_cart_order_price/', callback, undefined, error)
}

function reqCalculateOrderPrice(
  order_id: number,
  callback: (bidPrice: IOrderPrice) => void,
  error?: VoidFunction
) {
  reqGet('api/calculate_order_price/' + order_id, callback, undefined, error)
}

function reqUpdateNewOrderPrarmeter(
  orderId: number,
  parameterKey: string,
  value: string | number | null,
  callback: TOneItemCallback<ICartOrder>
) {
  reqPost('api/update_cart_order_parameter/', { orderId, parameterKey, value }, callback)
}

function reqRequestCartOrder(
  callback: TStatusCallbak,
  name?: string,
  phone?: string,
  email?: string,
  code?: number
) {
  reqPost('api/request_cart_order/', { name, phone, email, code }, callback)
}

function reqAddProductToCart(productId: number, callback: TOneItemCallback<ICartOrder>) {
  reqPost('api/add_product_to_cart/', { productId }, callback)
}

function reqChangeCartProductQuantity(
  productId: number,
  quantity: number,
  callback: TOneItemCallback<ICartOrder>
) {
  reqPost('api/change_cart_product_quantity/', { productId, quantity }, callback)
}

function reqRemoveProductFromCart(
  productId: number,
  callback: TOneItemCallback<ICartOrder>
) {
  reqPost('api/remove_product_from_cart/', { productId }, callback)
}

function reqSendRequestCartCode(phone: string, captcha: string, captchaHash: string, callback: TStatusCallbak) {
  reqPost('api/send_request_cart_code/', { phone, captcha, captchaHash }, callback)
}

function reqConfirmRequestCartPhone(
  phone: string,
  code: number,
  callback: TStatusCallbak
) {
  reqPost('api/confirm_request_cart_phone/', { phone, code }, callback)
}

export {
  reqGetCartOrder,
  reqCalculateCartOrderPrice,
  reqCalculateOrderPrice,
  reqUpdateNewOrderPrarmeter,
  reqRequestCartOrder,
  reqAddProductToCart,
  reqChangeCartProductQuantity,
  reqRemoveProductFromCart,
  reqSendRequestCartCode,
  reqConfirmRequestCartPhone,
}
